import { useEffect, useState } from "react";
import { api, errorMsg } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Copy } from "lucide-react";

export function ServicioDuplicadosDialog({ abierto, onCerrar, onFusionarGrupo }) {
  const [cargando, setCargando] = useState(false);
  const [grupos, setGrupos] = useState([]);

  useEffect(() => {
    if (!abierto) return;
    setCargando(true);
    api.get("/servicios/duplicados")
      .then((r) => setGrupos(r.data || []))
      .catch((e) => toast.error(errorMsg(e)))
      .finally(() => setCargando(false));
  }, [abierto]);

  return (
    <Dialog open={abierto} onOpenChange={(o) => { if (!o) onCerrar?.(); }}>
      <DialogContent data-testid="servicio-duplicados-dialog" className="max-w-2xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Copy size={18} /> Posibles servicios duplicados</DialogTitle>
          <DialogDescription>Grupos con nombres muy parecidos. Usted confirma cada fusión; nunca es automática.</DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto space-y-3">
          {cargando && <p className="text-sm text-slate-400 py-6 text-center">Buscando…</p>}
          {!cargando && grupos.length === 0 && (
            <p data-testid="servicio-duplicados-vacio" className="text-sm text-slate-400 py-6 text-center">
              No se encontraron servicios con nombres parecidos.
            </p>
          )}
          {!cargando && grupos.map((g, i) => (
            <div key={i} data-testid={`servicio-duplicados-grupo-${i}`} className="border border-slate-200 rounded-lg p-3">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-semibold uppercase text-slate-500">{g.servicios.length} similares</span>
                <Button size="sm" data-testid={`servicio-duplicados-fusionar-${i}`}
                  onClick={() => onFusionarGrupo(g.servicios.map((s) => s.id))}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white h-7 text-xs">Fusionar este grupo</Button>
              </div>
              <ul className="space-y-1">
                {g.servicios.map((s) => (
                  <li key={s.id} className="text-sm text-slate-700 flex items-center gap-2 flex-wrap">
                    <span className="font-medium">{s.nombre}</span>
                    {s.tiene_plantillas && <span className="text-[10px] font-bold uppercase text-emerald-600 bg-emerald-100 px-1.5 py-0.5 rounded">{s.num_plantillas} plantilla(s)</span>}
                    {s.solo_cronograma && <span className="text-[10px] text-amber-600">solo cronograma</span>}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="flex justify-end pt-3 border-t border-slate-100 shrink-0">
          <Button variant="outline" data-testid="servicio-duplicados-cerrar-btn"
            className="border-teal-500 text-teal-600 hover:bg-teal-50" onClick={() => onCerrar?.()}>Cerrar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
